<template>
  <div class="lb-table-mini" :class="{ 'is-goods-selector': isGoodsSelector }">
    <el-table ref="elTable" v-bind="$attrs" v-on="$listeners" :data="data"
      :span-method="this.merge ? this.mergeMethod : this.spanMethod">
      <lb-column v-bind="$attrs" v-for="(item, index) in column" :key="index" :column="item">
      </lb-column>
    </el-table>
    <div class="mini-pagination">
      <div class="table-info">
        {{ statisticText }}: {{ orderStatistics }}
      </div>
      <div class="mini-pagination-con">
        <div class="btn-refresh primary" @click="$emit('refresh')">刷新<i class="el-icon-refresh"></i></div>
        <el-pagination class="lb-table-pagination" v-if="pagination" v-bind="$attrs" v-on="$listeners"
          @current-change="paginationCurrentChange"
          :style="{ 'margin-top': paginationTop, 'text-align': paginationAlign }">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import LbColumn from './lb-column'
export default {
  props: {
    column: Array,
    data: {
      type: Array,
      default: () => []
    },
    spanMethod: Function,
    pagination: {
      type: Boolean,
      default: false
    },
    paginationTop: {
      type: String,
      default: '0'
    },
    paginationAlign: {
      type: String,
      default: 'right'
    },
    orderStatistics: {
      type: [Object, Number],
      default: () => ({})
    },
    merge: Array,
    // 统计文案类型属性
    statisticText: {
      type: String,
      default: '当前列表统计总供应商数'
    },
    // 新增：是否为商品选择器表格
    isGoodsSelector: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LbColumn
  },
  data() {
    return {
      mergeLine: {},
      mergeIndex: {}
    }
  },
  created() {
    this.getMergeArr(this.data, this.merge)
  },
  computed: {
    dataLength() {
      return this.data.length
    },
    // todo 
    dataTotalPrice() {
      return '120.00'
    },
    // 获取当前页面的高度 - 根据是否为商品选择器调整高度
    // tableHeight() {
    //   return this.isGoodsSelector ? '300px' : 'calc(100vh - 180px)'
    // }
  },
  methods: {

    clearSelection() {
      this.$refs.elTable.clearSelection()
    },
    toggleRowSelection(row, selected) {
      this.$refs.elTable.toggleRowSelection(row, selected)
    },
    toggleAllSelection() {
      this.$refs.elTable.toggleAllSelection()
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.elTable.toggleRowExpansion(row, expanded)
    },
    setCurrentRow(row) {
      this.$refs.elTable.setCurrentRow(row)
    },
    clearSort() {
      this.$refs.elTable.clearSort()
    },
    clearFilter(columnKey) {
      this.$refs.elTable.clearFilter(columnKey)
    },
    doLayout() {
      this.$refs.elTable.doLayout()
    },
    sort(prop, order) {
      this.$refs.elTable.sort(prop, order)
    },
    paginationCurrentChange(val) {
      this.$emit('p-current-change', val)
    },
    getMergeArr(tableData, merge) {
      if (!merge) return
      this.mergeLine = {}
      this.mergeIndex = {}
      merge.forEach((item, k) => {
        tableData.forEach((data, i) => {
          if (i === 0) {
            this.mergeIndex[item] = this.mergeIndex[item] || []
            this.mergeIndex[item].push(1)
            this.mergeLine[item] = 0
          } else {
            if (data[item] === tableData[i - 1][item]) {
              this.mergeIndex[item][this.mergeLine[item]] += 1
              this.mergeIndex[item].push(0)
            } else {
              this.mergeIndex[item].push(1)
              this.mergeLine[item] = i
            }
          }
        })
      })
    },
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      const index = this.merge.indexOf(column.property)
      if (index > -1) {
        const _row = this.mergeIndex[this.merge[index]][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    }
  },
  watch: {
    merge() {
      this.getMergeArr(this.data, this.merge)
    },
    dataLength() {
      this.getMergeArr(this.data, this.merge)
    }
  }
}

</script>
<style lang="scss" scoped>
// 表格
.lb-table-mini {
  border-right: 1px solid #DDD;

  // 为非商品选择器表格设置高度
  &:not(.is-goods-selector) {
    // 设置表格容器高度，包含分页区域
    height: calc(100vh - 390px);
    display: flex;
    flex-direction: column;
    position: relative;

    /deep/ .el-table {
      flex: 1;
      overflow: hidden;
      // 重要：确保表格wrapper能正确计算高度
      height: 100% !important;

      // 修复表格主体滚动区域
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 37px) !important; // 减去表头高度

        // 确保滚动条可见
        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }
      }

      // 修复固定列的高度问题 - 添加超出底部隐藏
      .el-table__fixed,
      .el-table__fixed-right {
        height: 98.5% !important;
        top: 0 !important;
        bottom: 0 !important;

        .el-table__fixed-header-wrapper {
          top: 0 !important;
        }

        .el-table__fixed-body-wrapper {
          height: calc(100% - 37px) !important; 
          overflow: hidden !important;
          
          // 确保内容不会超出容器
          .el-table__fixed-body {
            overflow: hidden !important;
          }
        }
        
        // 修复固定列底部的边角区域
        .el-table__fixed-right-patch {
          bottom: 0 !important;
        }
      }
    }

    .mini-pagination {
      flex-shrink: 0;
      position: sticky;
      bottom: -20px;
      background-color: #ffffff;
      z-index: 10;
      border-top: 1px solid #DDD;
      margin-top: auto;
    }
  }

  /deep/ {
    // 移除之前设置的固定高度，让表格自身管理
    .el-table__body-wrapper {
      height: auto !important;
    }

    .el-table__fixed-body-wrapper {
      top: 28px !important;
    }

    .el-table__body-wrapper {
      scrollbar-width: thin;
    }

    .el-table--border,
    .el-table--group,
    .el-table th.el-table__cell.is-leaf,
    .el-table td.el-table__cell {
      border-color: #DDD;
    }

    .el-table th.el-table__cell {
      background-color: #F1F2F3;

      .cell {
        font-size: 12px;
        color: #333;
        font-weight: normal;
        padding: 6px 6px 5px 6px;
        line-height: 12px;
        height: auto;
      }
    }

    .el-table .el-table__cell {
      padding: 0;

      .cell {
        font-size: 12px;
        height: 40px;
        display: flex;
        align-items: center;
        color: #333;
        font-weight: normal;
        padding: 6px;
        line-height: 1;
      }
    }

    .el-table__body tr.hover-row>td.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
      background-color: #E3F0FC;
    }

    .el-table__body tr.click-row>td.el-table__cell {
      background-color: #fcedbc;
    }

    .el-table .el-table__cell.is-left {
      text-align: left;
    }

    .el-table .el-table__cell.is-left .flex {
      justify-content: flex-start;
    }

    .el-table .el-table__cell.is-center .flex {
      justify-content: center;
    }

    .el-table .el-table__cell.is-right .flex {
      justify-content: flex-end;
    }

    .el-table .el-table__cell.is-left .column {
      align-items: start;
      ;
    }

    .el-table .el-table__cell.is-center .column {
      align-items: center;
      ;
    }

    .el-table .el-table__cell.is-right .column {
      align-items: end;
    }
  }
}

// 分页
.mini-pagination {
  padding: 0 10px 0 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  background-color: #ffffff;
  margin-left: -26px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);

  .table-info {
    flex: 1;
    text-align: left;
  }

  .mini-pagination-con {
    padding: 10px 0;
    display: flex;
    align-items: center;

    .btn-refresh {
      margin: 0 10px;
      cursor: pointer;
      flex-shrink: 0;
    }
  }

  .lb-table-pagination {
    padding: 0;

    /deep/ {
      .el-pagination__total,
      .el-pagination__sizes,
      .el-select,
      .btn-prev,
      .btn-next,
      .el-pager li,
      .el-pagination__jump {
        font-size: 12px;
        height: 24px;
        line-height: 24px;
      }

      .el-pagination__jump {
        .el-input__inner {
          height: 24px;
        }
      }
    }
  }
}
</style>